<!--
  --
  -- アプリケーションタイトル コンポーネント
  --
  -- 組織ロゴを表示する
  --
  -->

<!-- モバイル -->
<template v-if="$vuetify.breakpoint.xsOnly">
  <a :href="rootRoute">
    <v-app-bar-title>
      <img class="logo" :src="logo" />
    </v-app-bar-title>
  </a>
</template>

<!-- PC -->
<template  v-else>
  <a :href="rootRoute">
    <v-app-bar-title>
      <img class="logo_L" :src="logo" />
    </v-app-bar-title>
  </a>
</template>

<style lang="scss">
.logo {
  display: block;
  max-width: 176px;
  max-height: 36px;
  object-fit: contain;
}
.logo_L {
  display: block;
  max-width: 311px;
  max-height: 56px;
  object-fit: contain;
}
</style>

<script>
export default {
  name: 'CTitle',
  computed: {
    logo () {
      const orgcode = this.getters['org/code']
      return (orgcode) ? `/reserve/res/${orgcode}/logo.png` : null
    },

    /**
     * トップページ
     */
    rootRoute () {
      // const orgcode = this.getters['org/code']
      // return `/reserve/${orgcode}`
      return this.getters['org/topURL']
    }
  }
}
</script>
